import df from 'dateformat';

export const replaceImageUri = (uri, size) => {
  return uri && uri.replace('{size}', size);
};

export const replaceStyleImageUri = (uri, size) => {
  const sizeAndStylePattern = /\{style\}|\{size\}/;
  return uri && uri.replace(sizeAndStylePattern, size);
};

export const isDesktop = () => {
  return typeof window === 'object' && window.innerWidth > 767;
};

export const debounce = (func, wait, immediate) => {
  let timeout;
  const args = arguments;
  const later = () => {
    timeout = null;
    if (!immediate) func.apply(this, args);
  };

  const callNow = immediate && !timeout;
  clearTimeout(timeout);
  timeout = setTimeout(later, wait);

  if (callNow) {
    func.apply(this, args);
  }
};

export const split = (initialText) => {
  return initialText.split(/(?:\r\n|\r|\n)/g);
};

export const formatDate = (date, format) => {
  return date && df(date.substring(0, 10), format);
};

export const date = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1;
  const yyyy = today.getFullYear();

  if (dd < 10) {
    dd = `0${dd}`;
  }

  if (mm < 10) {
    mm = `0${mm}`;
  }

  return `${dd}${mm}${yyyy}`;
};

export const linkUrl = (path, source) => {
  const pathUrl = source ? `${path}?utm_source=${source}&utm_medium=social&utm_campaign=social_share_${date()}` : path;
  return encodeURIComponent(pathUrl);
};



// WEBPACK FOOTER //
// ./src/components/storefront/utils/index.js